import { CoachInformationList } from './styles';

interface Props {
  userInfo?: any;
  clinicalDataList?: {
    id: number;
    title: string;
    age: number;
    sex: string;
    criteria: string;
    beforeImages: string;
    afterImages: string;
    afters: { resizedLink: string }[];
    befores: { resizedLink: string }[];
  }[];
}

import { IGetClinicalDataList } from '#types/clinicalData';

import Portfolio from 'src/refactor_components/my-page/profile/portfolio';
// import Badge from 'src/refactor_components/my-page/profile/badge';
import Articles from 'src/refactor_components/my-page/profile/articles';
import Introduce from 'src/refactor_components/my-page/profile/introduce';
import Qualifications from 'src/refactor_components/my-page/profile/qualifications';
import Criterias from 'src/refactor_components/my-page/profile/criterias';
// import FibudCertification from 'src/refactor_components/my-page/profile/fibud-certification';

export const CoachIntroduce = ({ userInfo, clinicalDataList }: Props) => {
  return (
    <CoachInformationList>
      {/* <Badge /> */}
      <Introduce
        introduction={userInfo?.introduction}
        shortIntroduction={userInfo?.shortIntroduction}
      />
      <Qualifications />

      <div className="flex flex-col">
        <Criterias
          criteriaItems={userInfo.degrees}
          criteriaTitle="학력"
          startTimeParam="from"
          endTimeParam="at"
          to="degrees"
          subCriteriaTitle="major"
        />
        <Criterias
          criteriaItems={userInfo.careers}
          criteriaTitle="경력"
          to="careers"
        />
        <Criterias
          criteriaItems={userInfo.licenses}
          criteriaTitle="자격증"
          certificateParam="gotAt"
          to="licenses"
        />
        <Criterias
          criteriaItems={userInfo.awards}
          criteriaTitle="수상"
          certificateParam="gotAt"
          to="awards"
        />
        <Criterias
          criteriaItems={userInfo.educations}
          criteriaTitle="교육"
          certificateParam="gotAt"
          to="educations"
        />
      </div>
      <Articles />
      <Portfolio clinicalDataList={clinicalDataList} />
      {/* {recommendGyms && <LecturePlacePage recommendGyms={recommendGyms} />} */}
    </CoachInformationList>
  );
};
